var BetStatus;
(function (BetStatus) {
    BetStatus[BetStatus["Lose"] = 0] = "Lose";
    BetStatus[BetStatus["Win"] = 1] = "Win";
    BetStatus[BetStatus["Pending"] = 2] = "Pending";
    BetStatus[BetStatus["Canceled"] = 3] = "Canceled";
    BetStatus[BetStatus["Unknown"] = 4] = "Unknown";
    BetStatus[BetStatus["Calculation"] = 5] = "Calculation";
    BetStatus[BetStatus["OnCancel"] = 6] = "OnCancel";
})(BetStatus || (BetStatus = {}));

export { BetStatus };
